// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1GjZ8","container":"styles_container__3uzKr","title":"styles_title__2dDbF","wrapper":"styles_wrapper__3LzRH","answer":"styles_answer__3MqHs"};